<form class="agent-form" [formGroup]="todoFormulario" novalidate>
  <div class="agent-profile">
    <span>Perfil: </span>
    <strong>{{ configuracionRegistro.perfilNombre }}</strong>
  </div>

  <section class="agent-alert">
    <span class="agent-alert__icon">
      <mat-icon>verified_user</mat-icon>
    </span>

    <div>
      <h2>Verificamos tu identidad para proteger tu cuenta</h2>
      <p>Tus datos están seguros con nosotros.</p>
    </div>
  </section>

  <section class="agent-section">
    <header class="agent-section__header">
      <mat-icon>lock</mat-icon>
      <h3>Datos de acceso</h3>
    </header>

    <div class="agent-fields-card">
      <div class="agent-field agent-field--with-field-error" [class.agent-field--invalid]="isInvalid('Cuenta')">
        <label for="agent-cuenta">{{ configuracionRegistro.etiquetaCuenta }}*</label>
        <input
          id="agent-cuenta"
          name="atlas-reg-agent-key"
          type="text"
          formControlName="Cuenta"
          [placeholder]="configuracionRegistro.placeholderCuenta"
          autocomplete="new-password"
          inputmode="numeric"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false">
          @if (isInvalid('Cuenta')) {
            <button
              type="button"
              class="agent-field__alert-button agent-field__alert-button--field agent-field__alert-button--error"
              aria-label="Ver detalle de clave agente"
              (click)="abrirErrorCampo('Cuenta')">
              <mat-icon>error_outline</mat-icon>
            </button>
          }
          @if (isInvalid('Cuenta')) {
            <small>{{ getError('Cuenta') }}</small>
          }
        </div>

        <div class="agent-field agent-field--with-field-error" [class.agent-field--invalid]="isInvalid('NIP')">
          <label for="agent-nip">NIP*</label>
          <input
            id="agent-nip"
            name="atlas-reg-nip"
            type="tel"
            formControlName="NIP"
            placeholder="Ingresa tu NIP"
            autocomplete="new-password"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false">
            @if (isInvalid('NIP')) {
              <button
                type="button"
                class="agent-field__alert-button agent-field__alert-button--field agent-field__alert-button--error"
                aria-label="Ver detalle de NIP"
                (click)="abrirErrorCampo('NIP')">
                <mat-icon>error_outline</mat-icon>
              </button>
            }
            @if (isInvalid('NIP')) {
              <small>{{ getError('NIP') }}</small>
            }
          </div>

          <div
            class="agent-field agent-field--with-status"
            [class.agent-field--invalid]="isInvalid('Usuario')">

            <label for="agent-usuario">Usuario*</label>

            <input
              id="agent-usuario"
              name="atlas-reg-user-key"
              type="text"
              formControlName="Usuario"
              placeholder="Ingresa tu usuario"
              minlength="4"
              maxlength="8"
              autocomplete="new-password"
              autocorrect="off"
              autocapitalize="none"
              spellcheck="false">
              <span class="agent-field__status">
                @if (usuarioValido.pending) {
                  <mat-icon
                    class="agent-field__status-icon agent-field__status-icon--pending">
                    sync
                  </mat-icon>
                }

                @if (usuarioValido.is && !usuarioValido.pending && todoFormulario.get('Usuario')?.valid) {
                  <mat-icon
                    class="agent-field__status-icon agent-field__status-icon--success">
                    check_circle
                  </mat-icon>
                }

                @if (isInvalid('Usuario') && !usuarioValido.pending && !usuarioValido.is) {
                  <button
                    type="button"
                    class="agent-field__alert-button agent-field__alert-button--status agent-field__alert-button--error"
                    aria-label="Ver detalle del usuario"
                    (click)="abrirInfoUsuario()">
                    <mat-icon>error_outline</mat-icon>
                  </button>
                }
              </span>

              @if (isInvalid('Usuario')) {
                <small>{{ getError('Usuario') }}</small>
              }
            </div>

            <div
              class="agent-field agent-field--with-action agent-field--alias"
              [class.agent-field--invalid]="isInvalid('Alias')">

              <label for="agent-alias">Alias o sobrenombre*</label>

              <input
                id="agent-alias"
                name="atlas-reg-alias-ref"
                type="text"
                formControlName="Alias"
                placeholder="Ingresa tu alias"
                autocomplete="new-password"
                autocorrect="off"
                autocapitalize="none"
                spellcheck="false">

                @if (isInvalid('Alias')) {
                  <button
                    type="button"
                    class="agent-field__alert-button agent-field__alert-button--field agent-field__alert-button--error"
                    aria-label="Ver detalle del alias"
                    (click)="abrirErrorCampo('Alias')">
                    <mat-icon>error_outline</mat-icon>
                  </button>
                }

                @if (!isInvalid('Alias')) {
                  <button
                    type="button"
                    class="agent-field__alert-button agent-field__alert-button--field agent-field__alert-button--info"
                    aria-label="Información sobre alias"
                    (click)="abrirInfoAlias()">
                    <mat-icon>info_outline</mat-icon>
                  </button>
                }

                @if (isInvalid('Alias')) {
                  <small>{{ getError('Alias') }}</small>
                }
              </div>

              <div
                class="agent-field agent-field--with-action agent-field--password"
                [class.agent-field--invalid]="isInvalid('Password')">

                <label for="agent-password">Contraseña*</label>

                <input
                  id="agent-password"
                  name="atlas-reg-access-pass"
                  [type]="hidePassword ? 'password' : 'text'"
                  formControlName="Password"
                  placeholder="Ingresa tu contraseña"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="none"
                  spellcheck="false"
                  readonly
                  (focus)="desbloquearAutofill($event)"
                  (blur)="bloquearAutofill($event)"
                  data-lpignore="true"
                  data-1p-ignore="true"
                  data-form-type="other">

                  <div class="agent-field__actions">
                    <button
                      type="button"
                      class="agent-field__icon-button"
                      (click)="hidePassword = !hidePassword"
                      aria-label="Mostrar u ocultar contraseña">
                      <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>

                    @if (mostrarIconoPasswordCorrecto()) {
                      <mat-icon
                        class="agent-field__success-icon">
                        check_circle
                      </mat-icon>
                    }

                    @if (isInvalid('Password')) {
                      <button
                        type="button"
                        class="agent-field__alert-button agent-field__alert-button--error"
                        aria-label="Ver detalle de contraseña"
                        (click)="abrirErrorPassword()">
                        <mat-icon>error_outline</mat-icon>
                      </button>
                    }
                  </div>

                  @if (isInvalid('Password')) {
                    <small>{{ getError('Password') }}</small>
                  }
                </div>

                <div
                  class="agent-field agent-field--with-action agent-field--password"
                  [class.agent-field--invalid]="isInvalid('ConfirmaPassword')">

                  <label for="agent-confirma-password">Confirma contraseña*</label>

                  <input
                    id="agent-confirma-password"
                    name="atlas-reg-access-pass-confirm"
                    [type]="hideConfirmPassword ? 'password' : 'text'"
                    formControlName="ConfirmaPassword"
                    placeholder="Confirma tu contraseña"
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="none"
                    spellcheck="false"
                    readonly
                    (focus)="desbloquearAutofill($event)"
                    (blur)="bloquearAutofill($event)"
                    data-lpignore="true"
                    data-1p-ignore="true"
                    data-form-type="other">
                    <div class="agent-field__actions">
                      <button
                        type="button"
                        class="agent-field__icon-button"
                        (click)="hideConfirmPassword = !hideConfirmPassword"
                        aria-label="Mostrar u ocultar confirmación de contraseña">
                        <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                      </button>

                      @if (mostrarIconoConfirmaPasswordCorrecto()) {
                        <mat-icon
                          class="agent-field__success-icon">
                          check_circle
                        </mat-icon>
                      }

                      @if (isInvalid('ConfirmaPassword')) {
                        <button
                          type="button"
                          class="agent-field__alert-button agent-field__alert-button--error"
                          aria-label="Ver detalle de confirmación de contraseña"
                          (click)="abrirErrorCampo('ConfirmaPassword')">
                          <mat-icon>error_outline</mat-icon>
                        </button>
                      }
                    </div>

                    @if (isInvalid('ConfirmaPassword')) {
                      <small>{{ getError('ConfirmaPassword') }}</small>
                    }
                  </div>
                </div>
              </section>

              <section class="agent-section">
                <header class="agent-section__header">
                  <mat-icon>verified_user</mat-icon>
                  <h3>Verificación de contacto</h3>
                </header>

                <div class="contact-card"
                  [class.contact-card--email-full]="!dosFaCorreoHabilitado"
                  [class.contact-card--phone-full]="!dosFaTelefonoHabilitado">
                  <div class="agent-field agent-field--with-field-error" [class.agent-field--invalid]="isInvalid('Email') || mostrarErrorUsuarioContacto('Email')">
                    <label for="agent-email">Email*</label>
                    <input
                      id="agent-email"
                      name="atlas-reg-contact-mail"
                      type="text"
                      inputmode="email"
                      formControlName="Email"
                      placeholder="correo@ejemplo.com"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="none"
                      spellcheck="false"
                      readonly
                      (focus)="desbloquearAutofill($event)"
                      (blur)="bloquearAutofill($event); verificarCorreoAlPerderFoco()"
                      data-lpignore="true"
                      data-1p-ignore="true"
                      data-form-type="other">
                      @if (isInvalid('Email')) {
                        <button
                          type="button"
                          class="agent-field__alert-button agent-field__alert-button--field agent-field__alert-button--error"
                          aria-label="Ver detalle del correo electrónico"
                          (mousedown)="$event.preventDefault()"
                          (click)="abrirErrorCampo('Email')">
                          <mat-icon>error_outline</mat-icon>
                        </button>
                      } @else if (
                        todoFormulario.get('Email')?.value &&
                        todoFormulario.get('Email')?.valid &&
                        !mostrarErrorUsuarioContacto('Email')
                      ) {
                        <span
                          class="agent-field__status"
                          role="status"
                          aria-label="Correo electrónico válido">
                          <mat-icon class="agent-field__status-icon agent-field__status-icon--success">
                            check_circle
                          </mat-icon>
                        </span>
                      }
                      @if (isInvalid('Email')) {
                        <small>{{ getError('Email') }}</small>
                      }
                      @if (mostrarErrorUsuarioContacto('Email')) {
                        <small
                          class="agent-field__dependency-error"
                          >
                          <span>{{ getErrorUsuarioContacto('Email') }}</span>
                        </small>
                      }
                    </div>

                    <button
                      type="button"
                      class="verify-button"
                      [class.verify-button--hidden]="!dosFaCorreoHabilitado"
                      [class.verify-button--ok]="!dosFaCorreoHabilitado || validandoCorreo"
                      [disabled]="consultandoNormaCorreo || !dosFaCorreoHabilitado || validandoCorreo || !todoFormulario.get('Email')?.valid || procesandoCorreo"
                      (click)="verificarCorreo()">

                      <mat-icon [class.verify-button__icon--spin]="consultandoNormaCorreo || procesandoCorreo">
                        {{ !dosFaCorreoHabilitado || validandoCorreo ? 'check_circle' : consultandoNormaCorreo || procesandoCorreo ? 'sync' : 'mail' }}
                      </mat-icon>

                      @if (dosFaCorreoHabilitado) {
                        <span>
                          {{ consultandoNormaCorreo ? 'Consultando' : validandoCorreo ? 'Verificado' : procesandoCorreo ? 'Enviando' : 'Click para verificar' }}
                        </span>
                      }
                    </button>

                    <div
                      class="agent-field agent-field--phone agent-field--with-field-error"
                      [class.agent-field--invalid]="isInvalid('Telefono') || mostrarErrorUsuarioContacto('Telefono')">

                      <label for="agent-telefono">Teléfono celular*</label>

                      <div class="phone-country-control">
                        <div class="phone-country-control__select-wrapper agent-select agent-select--compact">
                          <select
                            class="phone-country-control__select agent-select__control agent-select__control--country"
                            name="atlas-reg-phone-country"
                            [value]="codigoPaisTelefonoSeleccionadoKey"
                            autocomplete="off"
                            (change)="seleccionarCodigoPaisTelefono($event)">
                            @for (pais of codigosPaisTelefono; track pais) {
                              <option
                                [value]="getCodigoPaisTelefonoKey(pais)"
                                [selected]="getCodigoPaisTelefonoKey(pais) === codigoPaisTelefonoSeleccionadoKey">
                                {{ pais.pais }} +{{ pais.codigo }}
                              </option>
                            }
                          </select>

                          <mat-icon class="phone-country-control__chevron agent-select__chevron">
                            keyboard_arrow_down
                          </mat-icon>
                        </div>

                        <input
                          id="agent-telefono"
                          name="atlas-reg-contact-phone-local"
                          type="text"
                          inputmode="numeric"
                          [value]="telefonoLocal"
                          maxlength="10"
                          placeholder="10 dígitos"
                          autocomplete="off"
                          autocorrect="off"
                          autocapitalize="none"
                          spellcheck="false"
                          readonly
                          (focus)="desbloquearAutofill($event)"
                          (input)="capturarTelefonoLocal($event)"
                          (blur)="bloquearAutofill($event); verificarTelefonoAlPerderFoco()"
                          data-lpignore="true"
                          data-1p-ignore="true"
                          data-form-type="other">
                        </div>

                        @if (isInvalid('Telefono')) {
                          <button
                            type="button"
                            class="agent-field__alert-button agent-field__alert-button--field agent-field__alert-button--error"
                            aria-label="Ver detalle del teléfono celular"
                            (mousedown)="$event.preventDefault()"
                            (click)="abrirErrorCampo('Telefono')">
                            <mat-icon>error_outline</mat-icon>
                          </button>
                        } @else if (
                          telefonoTieneFormatoCorrecto() &&
                          !mostrarErrorUsuarioContacto('Telefono')
                        ) {
                          <span
                            class="agent-field__status"
                            role="status"
                            aria-label="Teléfono celular válido">
                            <mat-icon class="agent-field__status-icon agent-field__status-icon--success">
                              check_circle
                            </mat-icon>
                          </span>
                        }

                        @if (isInvalid('Telefono')) {
                          <small>{{ getError('Telefono') }}</small>
                        }
                        @if (mostrarErrorUsuarioContacto('Telefono')) {
                          <small
                            class="agent-field__dependency-error"
                            >
                            <span>{{ getErrorUsuarioContacto('Telefono') }}</span>
                          </small>
                        }
                      </div>

                      <button
                        type="button"
                        class="verify-button"
                        [class.verify-button--ok]="!dosFaTelefonoHabilitado || validandoTelefono"
                        [class.verify-button--hidden]="!dosFaTelefonoHabilitado"
                        [disabled]="!telefonoPuedeVerificarse()"
                        (click)="verificarTelefono()">

                        <mat-icon [class.verify-button__icon--spin]="consultandoNormaTelefono || procesandoTelefono">
                          {{ !dosFaTelefonoHabilitado || validandoTelefono ? 'check_circle' : consultandoNormaTelefono || procesandoTelefono ? 'sync' : 'phone_iphone' }}
                        </mat-icon>
                        @if (dosFaTelefonoHabilitado) {
                          <span>
                            {{ consultandoNormaTelefono ? 'Consultando' : validandoTelefono ? 'Verificado' : procesandoTelefono ? 'Enviando' : 'Click para verificar' }}
                          </span>
                        }
                      </button>
                    </div>
                  </section>

                  <section class="agent-section">
                    <header class="agent-section__header">
                      <mat-icon>vpn_key</mat-icon>
                      <h3>Pregunta de seguridad</h3>
                    </header>
                    <div class="agent-fields-card">
                      <div
                        class="agent-field agent-field--select"
                        [class.agent-field--invalid]="isInvalid('IdPregunta')">

                        <label for="agent-pregunta">Pregunta secreta*</label>

                        <div class="agent-select">
                          <select
                            id="agent-pregunta"
                            class="agent-select__control agent-select__control--question"
                            name="atlas-reg-secret-question"
                            formControlName="IdPregunta"
                            autocomplete="off">
                            <option [ngValue]="0">Selecciona una pregunta</option>
                            @for (pregunta of catPreguntas; track pregunta) {
                              <option [ngValue]="pregunta.Value">
                                {{ pregunta.Text }}
                              </option>
                            }
                          </select>

                          <mat-icon class="agent-select__chevron">keyboard_arrow_down</mat-icon>
                        </div>

                        @if (isInvalid('IdPregunta')) {
                          <small>{{ getError('IdPregunta') }}</small>
                        }
                      </div>

                      <div class="agent-field agent-field--with-field-error" [class.agent-field--invalid]="isInvalid('Respuesta')">
                        <label for="agent-respuesta">Respuesta*</label>
                        <input
                          id="agent-respuesta"
                          name="atlas-reg-secret-answer"
                          type="text"
                          formControlName="Respuesta"
                          placeholder="Escribe tu respuesta"
                          autocomplete="new-password"
                          autocorrect="off"
                          autocapitalize="none"
                          spellcheck="false">
                          @if (isInvalid('Respuesta')) {
                            <button
                              type="button"
                              class="agent-field__alert-button agent-field__alert-button--field agent-field__alert-button--error"
                              aria-label="Ver detalle de respuesta"
                              (click)="abrirErrorCampo('Respuesta')">
                              <mat-icon>error_outline</mat-icon>
                            </button>
                          }
                          @if (isInvalid('Respuesta')) {
                            <small>{{ getError('Respuesta') }}</small>
                          }
                        </div>
                      </div>
                    </section>

                    <section class="agent-section">
                      <header class="agent-section__header">
                        <mat-icon>person</mat-icon>
                        <h3>Datos personales</h3>
                      </header>

                      <div class="agent-fields-card">
                        <div class="agent-field agent-field--with-field-error" [class.agent-field--invalid]="isInvalid('Nombre')">
                          <label for="agent-nombre">Nombre*</label>
                          <input
                            id="agent-nombre"
                            name="atlas-reg-person-a"
                            type="text"
                            formControlName="Nombre"
                            placeholder="Ingresa tu nombre"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="none"
                            spellcheck="false"
                            readonly
                            (focus)="desbloquearAutofill($event)"
                            (blur)="bloquearAutofill($event)"
                            data-lpignore="true"
                            data-1p-ignore="true"
                            data-form-type="other">
                            @if (isInvalid('Nombre')) {
                              <button
                                type="button"
                                class="agent-field__alert-button agent-field__alert-button--field agent-field__alert-button--error"
                                aria-label="Ver detalle de nombre"
                                (click)="abrirErrorCampo('Nombre')">
                                <mat-icon>error_outline</mat-icon>
                              </button>
                            }
                            @if (isInvalid('Nombre')) {
                              <small>{{ getError('Nombre') }}</small>
                            }
                          </div>

                          <div class="agent-field agent-field--with-field-error" [class.agent-field--invalid]="isInvalid('Paterno')">
                            <label for="agent-paterno">Apellido paterno*</label>
                            <input
                              id="agent-paterno"
                              name="atlas-reg-person-b"
                              type="text"
                              formControlName="Paterno"
                              placeholder="Ingresa tu apellido paterno"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="none"
                              spellcheck="false"
                              readonly
                              (focus)="desbloquearAutofill($event)"
                              (blur)="bloquearAutofill($event)"
                              data-lpignore="true"
                              data-1p-ignore="true"
                              data-form-type="other">
                              @if (isInvalid('Paterno')) {
                                <button
                                  type="button"
                                  class="agent-field__alert-button agent-field__alert-button--field agent-field__alert-button--error"
                                  aria-label="Ver detalle de apellido paterno"
                                  (click)="abrirErrorCampo('Paterno')">
                                  <mat-icon>error_outline</mat-icon>
                                </button>
                              }
                              @if (isInvalid('Paterno')) {
                                <small>{{ getError('Paterno') }}</small>
                              }
                            </div>

                            <div class="agent-field agent-field--with-field-error" [class.agent-field--invalid]="isInvalid('Materno')">
                              <label for="agent-materno">Apellido materno*</label>
                              <input
                                id="agent-materno"
                                name="atlas-reg-person-c"
                                type="text"
                                formControlName="Materno"
                                placeholder="Ingresa tu apellido materno"
                                autocomplete="off"
                                autocorrect="off"
                                autocapitalize="none"
                                spellcheck="false"
                                readonly
                                (focus)="desbloquearAutofill($event)"
                                (blur)="bloquearAutofill($event)"
                                data-lpignore="true"
                                data-1p-ignore="true"
                                data-form-type="other">
                                @if (isInvalid('Materno')) {
                                  <button
                                    type="button"
                                    class="agent-field__alert-button agent-field__alert-button--field agent-field__alert-button--error"
                                    aria-label="Ver detalle de apellido materno"
                                    (click)="abrirErrorCampo('Materno')">
                                    <mat-icon>error_outline</mat-icon>
                                  </button>
                                }
                                @if (isInvalid('Materno')) {
                                  <small>{{ getError('Materno') }}</small>
                                }
                              </div>

                              <div class="agent-field agent-field--with-field-error" [class.agent-field--invalid]="isInvalid('RFC')">
                                <label for="agent-rfc">RFC*</label>
                                <input
                                  id="agent-rfc"
                                  name="atlas-reg-tax-ref"
                                  type="text"
                                  formControlName="RFC"
                                  placeholder="Ingresa tu RFC"
                                  autocomplete="off"
                                  autocorrect="off"
                                  autocapitalize="none"
                                  spellcheck="false"
                                  readonly
                                  (focus)="desbloquearAutofill($event)"
                                  (blur)="bloquearAutofill($event)"
                                  data-lpignore="true"
                                  data-1p-ignore="true"
                                  data-form-type="other">
                                  @if (isInvalid('RFC')) {
                                    <button
                                      type="button"
                                      class="agent-field__alert-button agent-field__alert-button--field agent-field__alert-button--error"
                                      aria-label="Ver detalle de RFC"
                                      (click)="abrirErrorCampo('RFC')">
                                      <mat-icon>error_outline</mat-icon>
                                    </button>
                                  }
                                  @if (isInvalid('RFC')) {
                                    <small>{{ getError('RFC') }}</small>
                                  }
                                </div>
                              </div>
                            </section>

                            <div class="agent-actions">
                              <button type="button" class="agent-button agent-button--secondary" (click)="regresar()">
                                Regresar
                              </button>

                              <button
                                type="button"
                                class="agent-button agent-button--primary"
                                [disabled]="loadingRegistro"
                                (click)="continuar()">

                                {{ loadingRegistro ? 'Registrando...' : 'Continuar' }}
                              </button>
                            </div>
                          </form>
